var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgetData.to)?_c('b-nav-item',{staticClass:"nav-crossLink",attrs:{"href":_vm.widgetData.to},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.widgetData.img,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }